module.exports = __webpack_public_path__ + "static/assets/c6dde2cce3381c30449a15507b0171b5.png";